import { render, staticRenderFns } from "./NoAccessError.vue?vue&type=template&id=0353c48e&scoped=true"
import script from "./NoAccessError.vue?vue&type=script&lang=js"
export * from "./NoAccessError.vue?vue&type=script&lang=js"
import style0 from "./NoAccessError.vue?vue&type=style&index=0&id=0353c48e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0353c48e",
  null
  
)

export default component.exports